import {Link} from 'react-router-dom';
import {ChevronRight} from 'lucide-react';
import type {RouterOutput} from '@common-web/lib/trpc';
import {RiskIndicator} from './RiskIndicator';
import {AssigneeAvatar} from './AssigneeAvatar';

export type OnboardingItem =
  RouterOutput['internal']['onboarding']['listOnboardings']['items'][number];

interface PipelinePhaseCardProps {
  onboarding: OnboardingItem;
}

export function PipelinePhaseCard({onboarding}: PipelinePhaseCardProps) {
  return (
    <Link to={`/onboarding/${onboarding.id}`}>
      <div className='bg-white rounded-lg border p-3 shadow-sm hover:shadow-md transition cursor-pointer'>
        <div className='flex items-start justify-between gap-2'>
          <span className='font-medium text-sm text-brand-navy truncate'>
            {onboarding.groupName}
          </span>
          <RiskIndicator level={onboarding.riskLevel} />
        </div>

        <div className='mt-2 space-y-1'>
          <div className='h-2 w-full bg-gray-200 rounded-full overflow-hidden'>
            <div
              className='h-full bg-emerald-500 rounded-full transition-all'
              style={{width: `${onboarding.progressPercent}%`}}
            />
          </div>
          <p className='text-xs text-brand-gray'>
            {onboarding.completedSteps}/{onboarding.totalSteps} steps
          </p>
          {onboarding.dryRunStepCount > 0 && (
            <p className='text-xs text-brand-gray mt-1'>
              Dry runs:{' '}
              {onboarding.dryRunPassCount + onboarding.dryRunFailCount === 0 ? (
                <span className='text-brand-gray-light'>no results yet</span>
              ) : (
                <>
                  <span className='text-emerald-600 font-medium'>
                    {onboarding.dryRunPassCount} pass
                  </span>
                  <span className='text-brand-gray-light'> · </span>
                  <span className='text-red-600 font-medium'>
                    {onboarding.dryRunFailCount} fail
                  </span>
                </>
              )}
            </p>
          )}
        </div>

        <div className='mt-2 flex items-center justify-between'>
          <div className='flex items-center gap-2'>
            {onboarding.assignedManager && (
              <AssigneeAvatar name={onboarding.assignedManager.name} size='sm' />
            )}
            <span className='text-xs text-brand-gray-light'>{onboarding.daysInPipeline}d</span>
          </div>
          <ChevronRight className='h-4 w-4 text-brand-gray-light' />
        </div>
      </div>
    </Link>
  );
}
